import React from 'react';
import timeErrorImg from '../../assets/images/timeError.png';
import TokenManager from '../../utils/TokenManager';
import '../DefaultOktaError/style.scss';
const TimeZoneMismatch = () => {
  const handleOk = () => {
    TokenManager.clearTokenDetails();
    TokenManager.clearAllCookies();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Time Zone Mismatch",
    src: timeErrorImg
  }), /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, __('Time Zone Mismatch')), /*#__PURE__*/React.createElement("div", {
    className: "subHeading"
  }, __("Oh no! Your system time is different from your Internet Provider's time. Please update your system's time to match your Internet Provider's time for accessing the page.")), /*#__PURE__*/React.createElement("div", {
    className: "retryBtn",
    onClick: handleOk
  }, __('Retry Login')));
};
export default TimeZoneMismatch;